import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addSportNew } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew/sportsNewQueryKeys";
import { AddSportNewParams } from "@/types/ApiResponses/Sport";

export const useAddSportNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddSportNewParams) => addSportNew(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportsNew],
      });
    },
  });
};
